import React from 'react';

const RejectLeaveModal = ({
    isOpen,
    onClose,
    selectedLeave,
    onReject,
    actionComments,
    setActionComments,
    isPending,
    formatDate
}) => {
    if (!isOpen || !selectedLeave) return null;

    return (
        <>
            <div className='fixed p-15 w-full max-w-[500px] left-[50%] top-[50%] translate-x-[-50%] translate-y-[-50%] z-[6]'>
                <div className='py-10 md:px-10 px-[7px] bg-bg-dark rounded-lg shadow-light'>
                    <h5 className="text-[16px]/[19.2px] font-medium md:px-10 px-[7px] py-10 mb-20 text-center border-b border-border">
                        Reject Leave Request
                    </h5>
                    <div className='my-10 md:px-10 px-[7px]'>
                        <p className='text-sm text-text-secondary mb-3'>
                            Rejecting leave for <strong>{selectedLeave.employee_name || selectedLeave.name || 'Employee'}</strong>
                        </p>
                        <p className='text-sm mb-15'>
                            {formatDate(selectedLeave.start_date || selectedLeave.fromDate)} - {formatDate(selectedLeave.end_date || selectedLeave.toDate)} ({selectedLeave.days || selectedLeave.duration} days)
                        </p>
                        <div className='form-group'>
                            <label className='text-sm mb-2 block'>Reason for Rejection *</label>
                            <textarea
                                rows={3}
                                placeholder='Please provide a reason for rejection...'
                                value={actionComments}
                                onChange={(e) => setActionComments(e.target.value)}
                                className='w-full bg-bg-light border border-border px-12 py-8 rounded-md text-sm focus:outline-none focus:border-primary resize-none'
                            />
                        </div>
                    </div>
                    <div className='md:px-10 px-[7px] flex gap-10 justify-end py-10'>
                        <button onClick={onClose} className='btn btn-outline-secondary'>
                            Cancel
                        </button>
                        <button onClick={onReject} className='btn btn-danger' disabled={isPending}>
                            {isPending ? 'Rejecting...' : 'Reject'}
                        </button>
                    </div>
                </div>
            </div>
            <div onClick={onClose} className='fixed z-[5] w-full h-full left-0 top-0 bg-bg-transparent backdrop-blur-[5px]'></div>
        </>
    );
};

export default RejectLeaveModal;
